function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsignIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 216",
    style: {
      enableBackground: "new 0 0 216 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M94.05,164.347c-0.986,0-1.97-0.375-2.723-1.128l-26.225-26.224c-1.503-1.503-1.503-3.94,0-5.443 c1.506-1.506,3.94-1.506,5.446,0l26.225,26.224c1.503,1.503,1.503,3.94,0,5.443C96.021,163.972,95.036,164.347,94.05,164.347z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M113.543,152.766l-21.386-21.387c5.246-0.303,10.369-2.404,14.327-6.363 c1.797-1.796,3.253-3.873,4.329-6.173c0.901-1.928,0.069-4.219-1.857-5.121c-1.929-0.902-4.22-0.067-5.118,1.857 c-0.694,1.488-1.636,2.83-2.799,3.993c-5.7,5.699-15.14,5.539-21.044-0.357l-4.362-4.362c-0.752-0.753-1.737-1.13-2.723-1.129 c-0.985,0-1.97,0.376-2.724,1.129c-1.127,1.127-1.409,2.78-0.845,4.17c0.188,0.463,0.47,0.898,0.845,1.273l37.912,37.913 c0.753,0.753,1.737,1.128,2.723,1.128s1.97-0.375,2.723-1.128C115.046,156.706,115.046,154.269,113.543,152.766z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M72.388,164.347c-0.992,0-1.982-0.381-2.735-1.14l-21.708-21.911 c-9.62-10.072-11.498-24.018-4.721-34.749c6.823-10.802,20.341-14.783,34.446-10.143l22.223,7.163 c2.023,0.653,3.135,2.821,2.483,4.846c-0.653,2.024-2.824,3.135-4.847,2.484l-22.245-7.172 c-12.927-4.257-21.671,0.797-25.548,6.935c-4.042,6.401-4.456,16.696,3.729,25.266l21.658,21.861 c1.497,1.512,1.485,3.949-0.025,5.446C74.347,163.975,73.368,164.347,72.388,164.347z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M121.95,51.653c0.986,0,1.97,0.375,2.723,1.128l26.225,26.224c1.503,1.503,1.503,3.94,0,5.443 c-1.506,1.506-3.94,1.506-5.446,0l-26.225-26.224c-1.503-1.503-1.503-3.94,0-5.443C119.979,52.028,120.964,51.653,121.95,51.653 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M102.457,63.234l21.386,21.387c-5.246,0.303-10.369,2.404-14.327,6.363 c-1.797,1.796-3.253,3.873-4.329,6.173c-0.901,1.928-0.069,4.219,1.857,5.121c1.929,0.902,4.22,0.067,5.118-1.857 c0.694-1.488,1.636-2.83,2.799-3.993c5.7-5.699,15.14-5.539,21.044,0.357l4.362,4.362c0.752,0.753,1.737,1.13,2.723,1.129 c0.985,0,1.97-0.376,2.724-1.129c1.127-1.127,1.409-2.78,0.845-4.17c-0.188-0.463-0.47-0.898-0.845-1.273l-37.912-37.913 c-0.753-0.753-1.737-1.128-2.723-1.128s-1.97,0.375-2.723,1.128C100.954,59.294,100.954,61.731,102.457,63.234z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.612,51.653c0.992,0,1.982,0.381,2.735,1.14l21.708,21.911 c9.62,10.072,11.498,24.018,4.721,34.749c-6.823,10.802-20.341,14.783-34.446,10.143l-22.223-7.163 c-2.023-0.653-3.135-2.821-2.483-4.846c0.653-2.024,2.824-3.135,4.847-2.484l22.245,7.172 c12.927,4.257,21.671-0.797,25.548-6.935c4.042-6.401,4.456-16.696-3.729-25.266l-21.658-21.861 c-1.497-1.512-1.485-3.949,0.025-5.446C141.653,52.025,142.632,51.653,143.612,51.653z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsignIconWhite);
export default __webpack_public_path__ + "static/media/asign-icon-white.1cb44880944f7e4141e34bdfe3dc342e.svg";
export { ForwardRef as ReactComponent };